'use client';

import React, { useEffect, useMemo, useState } from 'react';
import VerifyLevel1Modal from '@/app/account/components/verification/components/VerificationLevel_1/VerifyLevel1Modal/VerifyLevel1Modal';
import { useUser } from '@/store';

interface Input_CheckBoxProps {
	attestation: boolean;
	setAttestation: (attestation: boolean) => void;
}

const Input_CheckBox = ({
	attestation,
	setAttestation,
}: Input_CheckBoxProps) => {
	const user = useUser();
	const [isPerjuryChecked, setIsPerjuryChecked] = useState(false);
	const [isCitizenChecked, setIsCitizenChecked] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);

	useEffect(() => {
		if (user?.moreDetails?.attestation) {
			setIsPerjuryChecked(true);
			setIsCitizenChecked(true);
			setAttestation(true);
		}
	}, [user]);

	const isFormValid = useMemo(() => {
		return isPerjuryChecked && isCitizenChecked;
	}, [isPerjuryChecked, isCitizenChecked]);

	useEffect(() => {
		if (isFormValid) {
			setAttestation(true);
		}
	}, [isFormValid]);

	return (
		<>
			{isModalOpen && (
				<VerifyLevel1Modal
					isPerjuryChecked={isPerjuryChecked}
					setIsPerjuryChecked={setIsPerjuryChecked}
					isCitizenChecked={isCitizenChecked}
					setIsCitizenChecked={setIsCitizenChecked}
					setIsModalOpen={setIsModalOpen}
				/>
			)}

			<input
				name="attestation"
				type="checkbox"
				className="min-w-5 min-h-5"
				checked={attestation}
				onClick={() => {
					if (!isFormValid) setIsModalOpen(true);
				}}
				readOnly
			/>

			<label className="text-sm text-dove-white-o-70">
				I agree that I am required to pass KYC level 2 with official
				documentation in order to withdraw the equivalent of € 2,000.
			</label>
		</>
	);
};

export default Input_CheckBox;
